// extracted by mini-css-extract-plugin
module.exports = {"pagination":"style-module--pagination--BrkyY","btn":"style-module--btn--3ofzi","btnInactive":"style-module--btnInactive--mpAhY"};